import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import type { ComponentProps } from 'react'

interface Props {
  tier: App.LoyaltyTier
  size: 'S' | 'M'
}

const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyTextBlock>['variant']> = {
  S: 'small',
  M: 'medium',
}

function PriceRowLoyaltyPointsLoadingSkeleton({ tier, size }: Props) {
  return <BodyTextBlock
    variant={SIZES_BODY_TEXT_VARIANTS[size]}
    colour="neutral-one"
    weight="bold"
    startIcon={<LoyaltyTierIcon size="S" tier={tier} />}
  >
    <TextLoadingBox width="20ch" lines={1} />
  </BodyTextBlock>
}

export default PriceRowLoyaltyPointsLoadingSkeleton
